import React, { useState, useEffect } from "react";
import { Autocomplete } from "@react-google-maps/api";
import { MapPinIcon } from "@heroicons/react/24/solid";
import { useTranslation } from "react-i18next";
import { useRegionFinder } from "./RegionFinder";

const PlacesAutocomplete = ({
  onSelect,
  showOptional,
  initialAddress,
  title,
  placeholder,
  customClassName,
  customError,
  canEdit = true,
  showTitle = true,
}) => {
  const [autocomplete, setAutocomplete] = useState(null);
  const [location, setLocation] = useState(initialAddress || ""); // Adresse initiale
  const [coordinates, setCoordinates] = useState({
    latitude: null,
    longitude: null,
    formattedAddress: "",
  });
  const [isEditing, setIsEditing] = useState(false); // Indique si l'utilisateur modifie
  const { t } = useTranslation();
  const { region, findRegion, loading, error } = useRegionFinder();
  const [deliveryAddress, setDeliveryAddress] = useState(""); // string affichée
  const [deliveryAddressObj, setDeliveryAddressObj] = useState(null); // objet complet (lat/lng/regionId)
  const [addressValidated, setAddressValidated] = useState(false);
  const addressText =
    deliveryAddress?.trim() ||
    deliveryAddressObj?.formattedAddress?.trim() ||
    "";

  useEffect(() => {
    setLocation(initialAddress || "");
  }, [initialAddress]);

  const handlePlaceChanged = () => {
    if (autocomplete) {
      const place = autocomplete.getPlace();
      if (!place.geometry || !place.address_components) {
        console.error("Adresse invalide ou hors Québec.");
        return;
      }

      const addressComponents = place.address_components || [];
      const isQuebec = addressComponents.some((component) => {
        return (
          component.short_name === "QC" || component.long_name === "Québec"
        );
      });

      if (isQuebec) {
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        const formattedAddress = place.formatted_address;
        let newCoordinates = {};
        findRegion(parseFloat(latitude), parseFloat(longitude)).then(
          (region) => {
            newCoordinates = {
              latitude,
              longitude,
              formattedAddress,
              regionId: region
                ? parseInt(region["@id"].replace("relation/", ""), 10)
                : null,
            };

            setLocation(formattedAddress);
            setCoordinates(newCoordinates);
            if (onSelect) {
              onSelect(newCoordinates);
            }
          }
        );
      } else {
        console.error("Adresse en dehors du Québec.");
      }
    }
  };

  return (
    <div className="text-primary">
      {/* Localisation */}
      <div>
        <div className="flex">
          <label className="block text-sm font-medium text-gray-700 mr-2">
            {showTitle && (title || "Saisissez une adresse")}
          </label>
          {showOptional && (
            <label className="block text-sm font-medium">
              <span className="text-gray-500">{t("modal.optional")}</span>
            </label>
          )}
        </div>

        <div className="relative">
          <MapPinIcon className="absolute left-3 top-3 w-5 h-5 text-gray-500" />
          <Autocomplete
            onLoad={(autocompleteInstance) => {
              setAutocomplete(autocompleteInstance);
            }}
            onPlaceChanged={handlePlaceChanged}
            options={{
              componentRestrictions: { country: "ca" },
              types: ["geocode"],
              fields: ["address_components", "geometry", "formatted_address"],
            }}
          >
            <input
              type="text"
              value={location}
              onChange={(e) => {
                setIsEditing(true);
                setLocation(e.target.value);
              }}
              disabled={!canEdit}
              autoComplete="off"
              placeholder={placeholder || "Entrez une adresse au Québec"}
              className={`w-full border bg-white shadow-md ${
                customError ? "border-red-500" : ""
              } rounded-md pl-10 pr-4 py-3 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary ${customClassName}`}
            />
          </Autocomplete>
        </div>
      </div>
      {/*coordinates.latitude && coordinates.longitude && (
        <p className="mt-2 text-sm text-gray-500">
          Coordonnées : {coordinates.latitude}, {coordinates.longitude}
        </p>
      )*/}
      {customError && <p className="text-sm text-red-500">{customError}</p>}
    </div>
  );
};

export default PlacesAutocomplete;
